import './PriorityManagement.scss';
import { v4 as uuid } from 'uuid';
import { QueueManagementConstants } from './../../QueueManagementConstants';
import { PriorityRuleUtilsService } from '../../../priorityRules/services/PriorityRuleUtilsService';
import { ToastType } from 'modules/application/misc/ToastService';
import { PriorityTracks } from '../../../priorityRules/PriorityTracksConstants';
export class PriorityContainerController {
    static $inject = ['LoadingService', 'AlertService', 'PriorityRulesService', '$translate', 'LoadValues', 'PermissionsService', 'BlipToastService', 'SegmentService'];
    constructor(LoadingService, AlertService, PriorityRulesService, $translate, LoadValues, PermissionsService, BlipToastService, SegmentService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.AlertService = AlertService;
        this.PriorityRulesService = PriorityRulesService;
        this.$translate = $translate;
        this.LoadValues = LoadValues;
        this.PermissionsService = PermissionsService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.isViewing = QueueManagementConstants.STATES.VIEWING;
        this.isAdding = QueueManagementConstants.STATES.ADDING;
        this.isEdit = QueueManagementConstants.STATES.EDITING;
        this.itemsPerPage = 100;
    }
    async $onInit() {
        this.setIsLoading(false);
        this.perPageAux = 0;
        this.priorities = [];
        this.filteredPriorities = [];
        this.prioritiesCount = 0;
        this.properties = await this.LoadValues.loadProperties();
        this.relations = await this.LoadValues.loadRelations();
        this.operators = await this.LoadValues.loadOperators();
        this.canEditRule = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
        if (this.queue.id) {
            await this.fetchPriorityRules();
        }
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    cancelAction(index) {
        if (this.currentState === QueueManagementConstants.STATES.ADDING) {
            this.filteredPriorities.splice(index, 1);
        }
        else if (this.currentState === QueueManagementConstants.STATES.EDITING) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(QueueManagementConstants.STATES.VIEWING);
    }
    async closeOpenedPriorityRule(index) {
        if (this.filteredPriorities[index].opened) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(QueueManagementConstants.STATES.VIEWING);
        await this.fetchPriorityRules();
    }
    async editPriorityRule(index) {
        this.setCurrentState(QueueManagementConstants.STATES.EDITING);
        await this.changeStatusItem(index);
    }
    async changeStatusItem(index) {
        for (const [i, priorityRule] of this.filteredPriorities.entries()) {
            priorityRule.opened = i === index ? !priorityRule.opened : false;
        }
    }
    checkLoadMoreStatus() {
        this.canLoadMore = this.priorities.length < this.prioritiesCount;
    }
    async changeStatus(value, index) {
        if (this.canEditRule) {
            const priority = {
                ...this.filteredPriorities[index],
                isActive: value,
            };
            this.savePriorityRule(priority, index);
        }
        else {
            this.PriorityRulesService.showToast('queue-management.errors.cannotEdit', ToastType.Danger);
        }
    }
    async createPriorityRule() {
        if (this.currentState === QueueManagementConstants.STATES.ADDING || this.currentState === QueueManagementConstants.STATES.EDITING) {
            return;
        }
        if (!this.queue.id) {
            const msg = await this.$translate('queue-management.errors.newNameBeforeEditPriorityRules');
            await this.BlipToastService.show(ToastType.Danger, { msg });
            return;
        }
        this.setCurrentState(QueueManagementConstants.STATES.ADDING);
        const title = await this.$translate('queue-management.priority.priorityRuleName');
        const newPriorityRule = {
            id: uuid(),
            title: `${title}`,
            conditions: [
                {
                    property: 'Message',
                    relation: 'Contains',
                    values: [],
                },
            ],
            queueId: this.queue.uniqueId,
            isActive: true,
            opened: true,
            operator: QueueManagementConstants.DEFAULT_OPERATOR,
            repeatConditionsBody: false,
            valuesEmpty: true,
            urgency: QueueManagementConstants.PRIORIRY_URGENCY,
            appyToAll: false,
        };
        this.filteredPriorities.unshift(newPriorityRule);
    }
    async togglePriorityRule(priorityRule) {
        await this.PriorityRulesService.set(this.application, priorityRule);
    }
    async savePriorityRule(data, index) {
        let priority;
        let toastMessageReference;
        let toastType;
        priority = {
            id: uuid(),
            ...data,
        };
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        toastMessageReference =
            this.currentState === QueueManagementConstants.STATES.ADDING
                ? 'queue-management.priority.confirmAddRule'
                : 'queue-management.priority.confirmEdit';
        try {
            priority.conditions = priority.conditions.map(condition => {
                if (condition.property?.includes(QueueManagementConstants.EXTRAS)) {
                    if (condition.extrasProperty) {
                        condition.property = PriorityRuleUtilsService.serializeExtrasProperies(condition.extrasProperty);
                    }
                    else {
                        condition.property = QueueManagementConstants.CONTACT_EXTRAS;
                    }
                }
                return condition;
            });
            await this.PriorityRulesService.set(this.application, priority);
            toastType = ToastType.Success;
        }
        catch (ex) {
            toastMessageReference = 'queue-management.errors.onAddOrUpdatePriority';
            toastType = ToastType.Danger;
        }
        finally {
            this.closeOpenedPriorityRule(index);
            await this.PriorityRulesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
        }
    }
    async confirmDelete(priorityRule) {
        try {
            const modalTitle = await this.$translate('queue-management.priority.confirmDeleteTitle');
            const modalBody = await this.$translate('queue-management.priority.confirmDeleteBody');
            const confirm = await this.$translate('queue-management.priority.actions.exclude');
            const cancel = await this.$translate('queue-management.priority.actions.abortAction');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.delete(priorityRule),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(priorityRule) {
        let toastMessageReference;
        let toastType;
        try {
            await this.PriorityRulesService.delete(priorityRule);
            await this.fetchPriorityRules();
            toastMessageReference = 'queue-management.priority.confirmRemoveRule';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack(PriorityTracks.PRIORITY_RULE_DELETED, this.application);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            await this.PriorityRulesService.showToast(toastMessageReference, toastType);
        }
    }
    isAnyPriorityRuleOpen() {
        return this.filteredPriorities.some(r => r.opened);
    }
    async fetchPriorityRules() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        try {
            this.priorities = [];
            const { priorityRules, total } = await this.PriorityRulesService.getPriorityRulesQueue(this.queue.uniqueId, this.perPageAux, this.itemsPerPage);
            this.priorities.push(...priorityRules);
            this.filteredPriorities = this.priorities.slice();
            this.prioritiesCount = total;
            this.checkLoadMoreStatus();
            this.setIsLoading(false);
            this.onChange({ $length: total || 0 });
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadMore() {
        const { priorityRules, total } = await this.PriorityRulesService.getPriorityRulesQueue(this.queue.uniqueId, this.priorities.length, this.itemsPerPage);
        this.priorities.push(...priorityRules);
        this.prioritiesCount = total;
        this.filteredPriorities = this.priorities.slice();
        this.checkLoadMoreStatus();
    }
}
PriorityContainerController.$inject = ['LoadingService', 'AlertService', 'PriorityRulesService', '$translate', 'LoadValues', 'PermissionsService', 'BlipToastService', 'SegmentService'];
